import { createFileRoute } from '@tanstack/react-router'

import { withRecordParam } from '@/components/kit/list/record-param'
import { depositFilters } from '@/features/money/deposit-filters'
import { DepositsPage } from '@/features/money/deposits-page'

export const Route = createFileRoute('/_app/deposits')({
    validateSearch: withRecordParam(depositFilters.parse, 'deposit'),
    component: DepositsPage,
    staticData: { crumb: 'Deposits' }
})
